import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindAll } from '@bibliocommons/utils-react';
import OnShelfButton from 'app/components/shared/OnShelfButton';
import { bibBriefShape } from '@bibliocommons/bc-prop-types';
import ShelfActions from 'app/actions/ShelfActions';
import { selectShelvesForCurrentUser, selectShelfTransactions } from 'app/selectors/ShelfSelector';
import AddToShelfComboButton from './AddToShelfComboButton';

export class AddToShelfComboButtonContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleShelfAdd(newShelf) {
    const { metadataId, reciprocalRank } = this.props;
    this.props.shelfActions.addToShelf({
      metadataId,
      shelfToAdd: newShelf,
      reciprocalRank
    });
  }

  handleClickOnMyShelf() {
    const { metadataId, workflowId } = this.props;
    const shelf = this.props.currentShelfItem.get('shelf');
    this.props.shelfActions.showPostAddToShelfView(metadataId, shelf, workflowId || metadataId);
  }

  render() {
    const { currentShelfItem, isAdding, bibBrief, disabled } = this.props;
    if (!currentShelfItem) {
      return (
        <AddToShelfComboButton
          primaryShelfAction={this.props.primaryShelfAction}
          disabled={disabled}
          isLoading={isAdding}
          bibBrief={bibBrief}
          handleClick={this.handleShelfAdd}
        />
      );
    }
    return (
      <div>
        <OnShelfButton
          disabled={disabled}
          shelfItem={currentShelfItem}
          bibBrief={bibBrief}
          handleClick={this.handleClickOnMyShelf}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { metadataId } = ownProps;
  const currentShelfItem = selectShelvesForCurrentUser(state).get(metadataId);
  const isAdding = selectShelfTransactions(state).getIn([metadataId, 'isAdding']);
  const bibBrief = state.getIn(['entities', 'bibs', metadataId, 'briefInfo']);
  return { currentShelfItem, isAdding, bibBrief };
};

const mapDispatchToProps = dispatch => ({
  shelfActions: bindActionCreators(ShelfActions, dispatch)
});

AddToShelfComboButtonContainer.propTypes = {
  currentShelfItem: ImmutablePropTypes.map,
  metadataId: PropTypes.string.isRequired,
  workflowId: PropTypes.string,
  isAdding: PropTypes.bool,
  disabled: PropTypes.bool,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  primaryShelfAction: PropTypes.string,
  reciprocalRank: PropTypes.number,
  bibBrief: bibBriefShape
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AddToShelfComboButtonContainer));
